import React from 'react'
import UIBody from '../../../components/ui/UIBody'
import InstitutionRegistration from './InstitutionRegistration'
import Training from './Training'
import Trainingplatform from './Trainingplatform'
import Registerclg from './Registerclg'
const CollageRegister = () => {
    return (
        <UIBody
            content={<>
                 <InstitutionRegistration/>
                 <Training/>
                 <Trainingplatform/>
                 <Registerclg/>
                </>
             

            }
        />
    )
}

export default CollageRegister
